var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill"},[_c('icon',{staticClass:"pill__icon",attrs:{"name":_vm.icon}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('icon',{staticClass:"pill__cta",attrs:{"name":"dropdown-open-indicator"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }